module.exports = __webpack_public_path__ + "static/media/emma.7fae15f4.jpg";